/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
*/

function format_cat(cant_va){
  
  const exp = /(\d)(?=(\d{3})+(?!\d))/g;
  const rep = '$1,';
  return "$ " + cant_va.toString().replace(exp,rep);
  
}

function update_cart_icon(cant){
	jQuery("#car_item_total").text(cant);
}

function increase_decrease_quantity(qty, variant_id){
  $.ajax({
       type: 'POST',
       url: '/cart/change.js',
       dataType: 'json',
       data: {
           quantity: qty,
           id: variant_id
       }
  }).done(function(cart){
  		
    	location.href = location.href;
  
  }).fail(function(jqXHR, textStatus, errorThrown){
  		//console.log(textStatus +  " - "  + errorThrown);
       serrorFunction(); 
  });

 

}
jQuery("button.modal__close.link").click(function(){
	jQuery(".modal1").slideUp(550);
});
jQuery("#content-account button.kafa__bton.kafa__bton__white").click(function(){
	
  	jQuery("#modal-address-new").slideDown(550);
    jQuery("#modal-address-new").css("display","flex");	
  	
});
jQuery(".conten_menu__mobile .kafa__menu__cat_mobile li a").click(function(){
    var a = jQuery(this).attr("data-id");
    jQuery("#"+a).toggle();
});

jQuery("button[data-action='open-modal']").click(function(){
	let vid = jQuery(this).attr("aria-controls");
  if(vid != "" && vid != null){
    jQuery("#" + vid).slideDown(550);
    jQuery("#" + vid).css("display","flex");
  }
});
// ----------------------------- filtros -----------------------------
jQuery(".kafa-col-twelve.kafa-col-mt-three.kafa-col-bg-three.filters__mobile .kafa__bton").click(function(){
	jQuery("#conten__collection_df").show(550);
    jQuery(".btn-whatsapp").hide(250);
});
jQuery(".filters__mobile_closed .kafa__bton").click(function(){
	jQuery("#conten__collection_df").hide(250);
    jQuery(".btn-whatsapp").show(250);
});

//-- --------------------- contenido del boton movil ----------------------------

jQuery(".mobile-button .kafa__bton").click(function(){
  	let acbt = jQuery(this).attr('data-active');
  if(acbt == "1"){
  	jQuery(".conten_menu__mobile").show(500);
    jQuery(this).attr('data-active','0');
  }else{
  	jQuery(".conten_menu__mobile").hide(300);
    jQuery(this).attr('data-active','1');
  }
	
});


// ---------------------------------------


$(".quantity-selector__button").click(function(){
  let qty_v = $(this).attr('data-quantity');
  let variant_id_v = $(this).attr('data-line-id');
  increase_decrease_quantity(qty_v,variant_id_v);
});

	//////////////////////// aparecer y desaparecer menu

    
  ///////////////////////// seccion del logueo ////////////////////////////////////////  
    jQuery("#login-account-xt").click(function(){
      if(jQuery(this).attr("data-action") == "toggle-popover"){
          //jQuery("#loginxt .wrapper").css("display","flex");
          jQuery("#loginxt .wrapper").show(500);
          jQuery(this).attr("data-action","toggle-popover-no")
      }else{
          //jQuery("#loginxt .wrapper").css("display","flex");
          jQuery("#loginxt .wrapper").hide(200);
          jQuery(this).attr("data-action","toggle-popover")
      }
  });
	jQuery("#btnClosed__pnl_account").click(function(){jQuery("#loginxt .wrapper").hide(200);jQuery(this).attr("data-action","toggle-popover"); }); 
  jQuery("#recoverPanel").click(function(){jQuery("#formContent").hide(200);jQuery("#formContentRecv").show(500);});
  jQuery("#createPanel").click(function(){jQuery("#formContent").hide(200);jQuery("#formContentCreate").show(500);});
  jQuery("#loginPanelCreate").click(function(){jQuery("#formContentCreate").hide(100);jQuery("#formContent").show(500);});
  jQuery("#loginPanel").click(function(){jQuery("#formContentRecv").hide(100);jQuery("#formContent").show(500);}); 
  jQuery("#extInstbtn").click(function(){ 
    let intEx = jQuery(this).attr('data-option'); 
    if (intEx == 'false'){ 
      jQuery("#extInst").toggle(500);
      jQuery(this).attr('data-option','true');
    }else{
      jQuery("#extInst").hide(200);
      jQuery(this).attr('data-option','false');
    } 
  });

  ///////////////////// CODIGO BUSCADOR PRINCIPAL /////////////////////////////////////////
  var currentUrl = new URL(window.location.protocol + '//' + window.location.host);  

   jQuery(".search-bar__input.kafa-form-bg").on('paste', function(e) {
      getValSearch(e.originalEvent.clipboardData.getData('text'));
    });  

    jQuery(".search-bar__input.kafa-form-bg").keyup(function(e){    

      	var a = jQuery(this).val(); 
      	getValSearch(a);  
     
    });

    let status = 1;

    function getValSearch(e){

       fetch(currentUrl + "search?view=ajax&q=" + e + "&type=product&options%5Bprefix%5D=last", {
            method: 'GET',
            credentials: 'same-origin'
          }).then(function (response) {
            response.text().then(function (content) {
              var linkSearchResults = document.querySelector('.link-search-results');

              if (linkSearchResults && content.trim() !== '') {
                linkSearchResults.innerHTML = content;
                jQuery(".link-search-results").fadeIn(200);

               jQuery( ".search-bar__input.kafa-form-bg" ).focus(function(){
                   jQuery(".link-search-results").fadeIn(300);
               });

              }else{
                linkSearchResults.innerHTML = '<h1 style="font-size:14px;">No se encontrarón resultados.</h1>';
              }		
               
              
              jQuery( ".search-bar__input.kafa-form-bg" ).focusout(function(){
                
                            
                jQuery(".link-search-results").mouseup(function(e){
                    //1: izquierda, 2: medio/ruleta, 3: derecho
                    if(e.which != 3) {
                         jQuery(".link-search-results").fadeOut(600);

                    }
                });
                
                
                
                   
              });

            });
          });  

    }

		jQuery("body").mousedown(function(e){
                 
                 tag = "";
                 if (e.srcElement){
                        tag = e.srcElement.tagName;
                 }else if (e.target){
                        tag = e.target.tagName;
				 }
                    //1: izquierda, 2: medio/ruleta, 3: derecho
                    //let w = jQuery(this).attr("class");
                 	//console.log(w);
                 //alert("Elemento seleccioado " + tag)
                    if(e.which != 3) {
                      if(tag != "input" ){
                         jQuery(".link-search-results").fadeOut(600);
                      }else{
                      	jQuery(".link-search-results").finish();
                        jQuery(".link-search-results").fadeIn();
                      }
                    }
                 
                });

  
  ///////////// Filtros de las colecciones ///////////////////////////////////////
  jQuery( ".card-tags__collection h4.h3 a" ).click(function(){
  	let a = jQuery(this).attr("data-id");
    let b = jQuery(this).attr("data-view");
    let c = jQuery(this).attr("id");
    let d = "#" + c + " svg"; let e = "#" + c + " svg path"; 
    if( b == 'false'){
    	jQuery(a).show(500);
      	jQuery(this).attr("data-view","true");
        jQuery( d ).removeClass("icon--arrow-bottom");
        jQuery( d ).addClass("icon--arrow-right");
        jQuery( d ).attr("viewBox","0 0 8 12");
        jQuery( e ).attr("d","M2 2l4 4-4 4");
      
    }else{
    	jQuery(a).hide(500);
        jQuery(this).attr("data-view","false");
        jQuery( d ).removeClass("icon--arrow-right");
        jQuery( d ).addClass("icon--arrow-bottom");
        jQuery( d ).attr("viewBox","0 0 12 8");
        jQuery( e ).attr("d","M10 2L6 6 2 2");
    }
  });
      
  
  jQuery("#orderCollection").change(function(){
  	let f = jQuery(this).val();
    window.location.href = "?sort_by=" + f;
  });

var w = 0;
      jQuery(document).ready(function(){
        var myVar = setInterval(function(){
        	jQuery("a[href='https://elfsight.com/youtube-channel-plugin-yottie/?utm_source=websites&utm_medium=clients&utm_content=yottie&utm_term=www.xtremepc.com.mx&utm_campaign=free-widget']").css("display",'none');
            jQuery("a[href='https://elfsight.com/google-reviews-widget/?utm_source=websites&utm_medium=clients&utm_content=google-reviews&utm_term=www.xtremepc.com.mx&utm_campaign=free-widget']").css("display","none");
        	jQuery("a[href='https://elfsight.com/youtube-channel-plugin-yottie/?utm_source=websites&utm_medium=clients&utm_content=yottie&utm_term=undefined&utm_campaign=free-widget']").css("display","none");
            jQuery('a[href="https://apps.elfsight.com/panel/applications/yottie?utm_source=websites&utm_medium=clients&utm_content=yottie&utm_term=www.xtremepc.com.mx&utm_campaign=deactivated-widget"]').remove();
            jQuery('a[href="https://elfsight.com/instagram-feed-instashow/?utm_source=websites&utm_medium=clients&utm_content=instagram-feed&utm_term=www.xtremepc.com.mx&utm_campaign=free-widget"]').remove();
            jQuery('a[href="https://apps.elfsight.com/panel/applications/instashow/?utm_source=websites&utm_medium=clients&utm_content=instagram-feed&utm_term=www.xtremepc.com.mx&utm_campaign=deactivated-widget&show_pricing=true"]').css('display','none');
            jQuery('a[href="https://apps.elfsight.com/panel/applications/instashow/?utm_source=websites&utm_medium=clients&utm_content=instagram-feed&utm_term=www.xtremepc.com.mx&utm_campaign=deactivated-widget&show_pricing=true"]').remove();
          	jQuery(".eapps-widget-toolbar").css("display","none");
          	if(w == 10){
            	clearInterval(myVar);
            }else{
                w = w + 1;
            }
        },2000);      	
      });


$('.alert__kafa').on('click', function(e) {
  if (e.target !== this)
    return;  
  jQuery(".alert__kafa").hide();
});

function add__card(qty,variant_id){
  let title = "";
  let content = "";
  
  $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         dataType: 'json',
         data: {
             quantity: qty,
             id: variant_id
         }
  }).done(function(cart){
    let price__for__pz = format_cat(parseFloat(cart.final_price / 100).toFixed(2));
	title ='<h4 style="color: #0751dd;font-weight: 600;">¡Producto agregado al carrito!</h4>',
    content = '<table><tr><td style="padding-left: 10px; padding-right: 10px;"><img src="' + cart.image + '" style="width: 120px;"></td><td style="padding-left: 20px; padding-right: 10px;font-size:12px;"><b style="color:#000;"> ' + cart.product_title + '</b><p class="price-price--highlight" style="font-size: 15px; color: #0370fb; text-shadow: 0 0 black;">' + price__for__pz + '</p></td></tr></table>'
    alert__kafa(title,content);
    let cant = jQuery(".product-form__quantity").val()
    let cart_icon = parseInt(jQuery("#car_item_total").text()) + parseInt(cant);

    jQuery("#car_item_total").text(cart_icon);

  }).fail(function(jqXHR, textStatus, errorThrown){
    //console.log(textStatus +  " - "  + jqXHR  + "-"  + errorThrown);
    //console.log(jqXHR);
    title = '<h4 style="color:#be0027;">'+ jqXHR.responseJSON.message + '</h4>',
    content = '<p style="color:#000;">' + jqXHR.responseJSON.description + '</p>'
    alert__kafa(title,content);
       //serrorFunction(); 
  });

}

	jQuery("#form-details-product").submit(function(e){
        e.preventDefault();
      
      let variant_iuu = jQuery("input[name='id']").val();
      let qty__variant = jQuery("select[name='quantity']").val();
      add__card(qty__variant,variant_iuu);
      	
    });alert__kafa

Shopify.postLink=function(t,e){
  var n=(e=e||{}).method||"post",i=e.parameters||{},
      o=document.createElement("form");
  for(var r in o.setAttribute("method",n),o.setAttribute("action",t),i){
    var l=document.createElement("input");l.setAttribute("type","hidden"),
      l.setAttribute("name",r),l.setAttribute("value",i[r]),
      o.appendChild(l)
  }
  document.body.appendChild(o),o.submit(),document.body.removeChild(o)
}

Shopify.CustomerAddress={
  toggleForm:function(e){
    var t=document.getElementById("edit_address_"+e),
        s=document.getElementById("view_address_"+e);
    return t.style.display="none"==t.style.display?"":"none",
      s.style.display="none"==s.style.display?"":"none",!1},
  toggleNewForm:function(){
    var e=document.getElementById("add_address");
    return e.style.display="none"==e.style.display?"":"none",!1},
  destroy:function(e,t){
    //console.log(e + " - " + t )
    confirm(t||"Are you sure you wish to delete this address?")&&Shopify.postLink("/account/addresses/"+e,{parameters:{_method:"delete"}})
  }
};
jQuery(".kafa__closed_alert.kafa__bton.kafa__bton__blue").click(function(){
	jQuery(".alert__kafa").hide();
});
function alert__kafa(t,c){
	jQuery(".alert__kafa .header__alert h4").html(t);
	jQuery(".alert__kafa .body__alert .content_text_alert").html(c);
  	jQuery(".alert__kafa").show();
}

/////////////////////////////// function Jquery Slider Carousell product /////////////////////////////////////////////////////

$num = $('.my-card').length;
$even =$num / 2;
$odd = ($num + 1) / 2;
//console.log($even + "  " + $odd);
if ($num % 2 == 0) {
  $('.my-card:nth-child(' + $even + ')').addClass('active');
  $('.my-card:nth-child(' + $even + ')').prev().addClass('prev');
  $('.my-card:nth-child(' + $even + ')').next().addClass('next');
} else {
  $('.my-card:nth-child(' + $odd + ')').addClass('active');
  $('.my-card:nth-child(' + $odd + ')').prev().addClass('prev');
  $('.my-card:nth-child(' + $odd + ')').next().addClass('next');

}

big_image_c();

$('.my-card').click(function() {
  var a = $(this).attr('disabled');
  if( a != 'disabled'){

    $slide = $('.active').width();
    //console.log($('.active').position().left);
    
    if ($(this).hasClass('next')) {
      $('.card-carousel').stop(false, true).animate({left: '-=' + $slide});
      big_image_c();
    } else if ($(this).hasClass('prev')) {
      $('.card-carousel').stop(false, true).animate({left: '+=' + $slide});
      big_image_c();
    }
    
    $(this).removeClass('prev next');
    $(this).siblings().removeClass('prev active next');
    
    $(this).addClass('active');
    $(this).prev().addClass('prev');
    $(this).next().addClass('next');
    
  }
  
});


// Keyboard nav
$('html body').keydown(function(e) {
  if (e.keyCode == 37) { // left
    $('.active').prev().trigger('click');
  }
  else if (e.keyCode == 39) { // right
    $('.active').next().trigger('click');
  }
});

 jQuery('#product-pages2 .kafa-col-two_picture_pro img').click(function(){
    			let srcArt = jQuery(this).attr('src');
                jQuery('#img_start').attr('src', srcArt);
    		});

jQuery("#iue1 a").click(function(){
    jQuery("#iue1 a").removeClass("activeApp");
    var a = jQuery(this).attr('data-id');
    jQuery(this).addClass("activeApp");
    jQuery("#iue2 .kafa-col-twelve.kafa-col-mt-twelve").hide();
    jQuery(a).show();
  });

//////////////////////////////////////////// big img ////////////////////////////////////////////

function big_image_c(){
  /*jQuery(".my-card.active img").click(function(){

   let img = jQuery(this).attr('src');
   jQuery("#image_big_zoom").attr('src', img );
   jQuery(".parent__img_big_panel").slideDown(1000);

  });

  jQuery("#image_big_panel").click(function(){
      jQuery(".parent__img_big_panel").slideUp(500);
  });*/
}
///////////////////////////////////// Modal SHARED ////////////////////////////////////////////////
jQuery("#close_modal_shared").click(function(){
	jQuery(".panel-principal-shared").hide();
});
jQuery("#compartir_btn").click(function(){
	jQuery(".panel-principal-shared").show();
});

$('.panel-principal-shared').on('click', function(e) {
  if (e.target !== this)
    return;  
  jQuery(".panel-principal-shared").hide();
});

////////////////////////////////// assign Videos //////////////////////////////////////////////////

jQuery("#menu_spec_des li").click(function(){
		jQuery("#menu_spec_des li").removeClass('active');
		jQuery(this).addClass('active');
		jQuery("#contendor_tab_panel .rowfa").removeClass('active');
		let id_gt = jQuery(this).attr('data-id');
		jQuery("#" + id_gt).addClass('active');
	});
  
	//var a = document.getElementsByClassName("product-meta__sku-number")[0].innerHTML;
    var a = $("#sku_product span").text();
  if(a == "CM-455" || a == "CM-456" || a == "CM-50045" || a == "CM-50100" || a == "CM-50116" || a == "CM-50118" || a == "CM-50119" || a == "CM-50190" || a == "CM-50215" || a == "CM-50216" || a == "CM-50335" || a == "CM-54004" || a == "CM-541" || a == "CM-54101" || a == "CM-60030" || a == "CM-60050" || a == "CM-60100" || a == "CM-71600" || a == "CM-71700" || a == "CM-50110" || a == "CM-71703" || a == "CM-60035" || a == "CM-55015" || a == "CM-50225" || a == "CM-50038" || a == "CM-54011" || a == "CM-60001" || a == "CM-71705" || a == "CM-50337" || a == "CM-50236" || a == "CM-55016" || a == "CM-55017" || a == "CM-50238" || a == "CM-50128" || a == "CM-54013" || a == "CM-54105" || a == "CM-54014" || a == "CM-54015" || a == "CM-50129" || a == "CM-50239" || a == "CM-60002"){
        var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/pQ1yNn6D3Ig');
        e.style.display="block";
     }

    if(a == "CM-05310" || a == "CM-05311" || a == "CM-206" || a == "CM-400" || a == "CM-412" || a == "CM-50150" || a == "CM-50205" || a == "CM-54100" || a == "CM-60040" || a == "CM-60060" || a == "CM-60071" || a == "CM-78020" || a == "CM-89100" || a == "CM-78010" || a == "CM-05312" || a == "CM-55001" || a == "CM-55002" || a == "CM-55003" || a == "CM-54106"){
        var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/TT2U4-zQ3To');
        e.style.display="block";
     }
    if(a == "CM-05313" || a == "CM-290" || a == "CM-50031" || a == "CM-50055" || a == "CM-50095" || a == "CM-50115" || a == "CM-50217" || a == "CM-50300" || a == "CM-50315" || a == "CM-54102" || a == "CM-54115" || a == "CM-60080" || a == "CM-71500" || a == "CM-71702" || a == "CM-78030" || a == "CM-89200" || a == "CM-50336" || a == "CM-89101" || a == "CM-89102" || a == "CM-54103" || a == "CM-78035" || a == "CM-60072" || a == "CM-78037" || a == "CM-78038" || a == "CM-50124" || a == "CM-50126" || a == "CM-50127" || a == "CM-50041" || a == "CM-50237" || a == "CM-54104"){
        var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/S5VhCnJIKyM');
        e.style.display="block";
     }
	if(a == "CM-55015" || a == "CM-60002"){
        var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/Fzd5npyB4OM');
        e.style.display="block";
     }
    if(a == "CM-50337" || a == "CM-60003" || a == "CM-60004" ){
        var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/kAvorf-bA58');
		e.style.display="block";
     }
     if(a == "CM-54016"){
        var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/YMnz7T323iM');
        e.style.display="block";
     }
     if(a == "CM-91005"){
        var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/QGUHLw8n5xs');
        e.style.display="block";
     }
      if(a == 'CM-50129'){
		var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/VGTFnlgVVE8');
        e.style.display="block";
      }
	  if(a == 'CM-50238' || a == 'CM-60005' || a == 'CM-60006' || a == 'CM-54022' || a == 'CM-54017'){
		var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/vgv4VE-5tU0');
        e.style.display="block";
      }
	  if(a == 'CM-30007'){
		var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/AVGTRqsIuF0');
        e.style.display="block";
      }
	  if(a == 'PW-36000'){
		var e = document.getElementById("BrandVideo");
        e.setAttribute('src','https://www.youtube.com/embed/m5PuRtFmVl8');
        e.style.display="block";
      }
/////////////////////////// REVIEWS ////////////////////////////////////////////////
      if(a == 'CM-30031'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/7T9m13DRpic');
          e.style.display="block";
      }
	  if(a == 'CM-91033'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/N4eWOGgMgZk');
          e.style.display="block";
      }
      if(a == 'CM-30021'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/WA4AAcO2t10');
          e.style.display="block";
      }
      if(a == 'CM-54112'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/DcikWWtNSv0');
          e.style.display="block";
      }
      if(a == 'CM-54016'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/bGb8pnIWYXQ');
          e.style.display="block";
      }
      if(a == 'CM-54018'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/EZoEjLXok3k');
          e.style.display="block";
      }
      if(a == 'CM-30020'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/IIazX0D9buM');
          e.style.display="block";
      }
      if(a == 'CM-50157'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/IusPmEQb9l4');
          e.style.display="block";
      }
      if(a == 'CM-50141'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/ZOq2kTLu01Q');
          e.style.display="block";
      }
      if(a == 'CM-54026'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/sTmhcNxIfZc');
          e.style.display="block";
      }
      if(a == 'CM-50155'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/ofVDxezieFc');
          e.style.display="block";
      }
      if(a == 'CM-54110'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/4UN55czCvYI');
          e.style.display="block";
      }
      if(a == 'CM-50245'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/eF0oy1RwSpk');
          e.style.display="block";
      }
      if(a == 'CM-20601'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/Dcz40kB5kIs');
          e.style.display="block";
      }
      if(a == 'CM-50338'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/cvBaXzvJptU');
          e.style.display="block";
      }
      if(a == 'CM-60032'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/PzS59lUFo9Q');
          e.style.display="block";
      }

	  if(a == 'CM-50339'){
		  var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/hZBsMMlh9xM');
          e.style.display="block";
	  }

	  if(a == 'CM-54017'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/LF3_NhBESM8');
          e.style.display="block";
      }
      if(a == 'CM-54114'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/oHBiq2qHU-4');
          e.style.display="block";
      }
      if(a == 'CM-05348'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/jFai90gXAAo');
          e.style.display="block";
      }



      if(a == 'CM-30037'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/dkxmZyQnHWo');
          e.style.display="block";
      }

	  if(a == 'CM-30040'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/0JW1kAgjTUo');
          e.style.display="block";
      }

	  if(a == 'CM-30039'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/G23_VBbyMzg');
          e.style.display="block";
      }
	  if(a == 'CM-30036'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/QIJeIxvCJPE');
          e.style.display="block";
      }
	  if(a == 'CM-91047'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/VohYNT2SfRo');
          e.style.display="block";
      }
	  if(a == 'CM-91046'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/VN0S-1-hwbM');
          e.style.display="block";
      }
	  if(a == 'CM-91045'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/_FC-Ny43oxE');
          e.style.display="block";
      }
	  if(a == 'CM-91030'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/jZPo-Lc00zM');
          e.style.display="block";
      }
	  if(a == 'CM-50084'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/nlUlqDaEW60');
          e.style.display="block";
      }



	  
	  if(a == 'CM-30034'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/qYePKt_SeEE');
          e.style.display="block";
      }
      if(a == 'CM-50144'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/rVlF0YlN464');
          e.style.display="block";
      }
      if(a == 'CM-91036'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/3rq9II0VKMs');
          e.style.display="block";
      }

	  if(a == 'CM-91041'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/9EtVS07AMXI');
          e.style.display="block";
      }
      if(a == 'CM-91040'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/9EtVS07AMXI');
          e.style.display="block";
      }
      if(a == 'CM-50129'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/BmYx9LXhvw4');
          e.style.display="block";
      }
      if(a == 'CM-55020'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/8316feCeJt8');
          e.style.display="block";
      }
	  if(a == 'CM-54116'){
          var e = document.getElementById("BrandVideoReview");
          e.setAttribute('src','https://www.youtube.com/embed/q56QRiuaR4k');
          e.style.display="block";
      }

/////////////////////////////////////////////////////////////////////////


///////////////////////////Nuevos vídeos para Xtreme///////////////////////////////////////
    if(a == 'CM-61021' || a == 'CM-05403' ||  a == 'CM-91008' ||  a == 'CM-91010' ||  a == 'CM-91008' ||  a == 'CM-50186' ||  a== "CM-05404" ||  a== "CM-99913" ||  a== "CM-99914" ||  a== "CM-99912" ||  a== "CM-05048" ||  a== "CM-50125" ||  a== "CM-05023" ||  a== "CM-05049" ||  a== "CM-05315" ||  a== "CM-05039" ||  a== "CM-91052" ||  a== "CM-91051" ||  a== "CM-99915" ||  a== "CM-91031" ||  a== "CM-02805" ||  a== "CM-99901" ||  a== "CM-99902" ||  a== "CM-30055" ||  a== "CM-05041" ||  a== "CM-91044" ||  a== "CM-50094" ||  a== "CM-91042" ||  a== "CM-053602" ||  a== "CM-053603" ||  a== "CM-05353" ||  a== "CM-91024" ||  a== "CM-053601" ||  a== "CM-05037" ||  a== "CM-91049" ||  a== "CM-50085" ||  a== "CM-30002" ||  a== "CM-50104" ||  a== "CM-30041" ||  a== "CM-91012" ||  a== "CM-50103" ||  a== "CM-50105" ||  a== "CM-50101" ||  a== "CM-50098" ||  a== "CM-50082" ||  a== "CM-50081" ||  a== "CM-50140" ||  a== "CM-50083" ||  a== "CM-05360" ||  a== "CM-50033" ||  a== "CM-05352" ||  a== "CM-50361" ||  a== "CM-91054" ||  a== "CM-02804" ||  a== "CM-05313" ||  a== "CM-91053" ||  a== "CM-30045" ||  a== "CM-91038" ||  a== "CM-61016" ||  a== "CM-50093" ||  a== "CM-30029" ||  a== "CM-07361" ||  a== "CM-30042" ||  a== "CM-05401" ||  a== "CM-05402" ||  a== "CM-54121" ||  a== "CM-91062" ||  a== "CM-50099" ||  a== "CM-50089" ||  a== "CM-30044" ||  a== "CM-30026" ||  a== "CM-91061" ||  a== "CM-91060" ||  a== "CM-54119" ||  a== "CM-05035" ||  a== "CM-91065" ||  a== "CM-50108" ||  a== "CM-50106" ||  a== "CM-50107" ||  a== "CM-50091" ||  a== "CM-99911" ||  a== "CM-91063" ||  a== "CM-99910" ||  a== "CM-30006" ||  a== "CM-30027" ||  a== "CM-50251" ||  a== "CM-05036" ||  a== "CM-30072" ||  a== "CM-05342" ||  a== "CM-61000" ||  a== "CM-30073" ||  a== "CM-50135" ||  a== "CM-91064" ||  a== "CM-30074" ||  a== "CM-55009" ||  a== "CM-50181" ||  a== "CM-30075" ||  a== "CM-50146" ||  a== "CM-54124" ||  a== "CM-50145" ||  a== "CM-54122" ||  a== "CM-50174" ||  a== "CM-54028" ||  a== "CM-54027" ||  a== "CM-60009" ||  a== "CM-50246" ||  a== "CM-71709" ||  a== "CM-50178" ||  a== "CM-55021" ||  a== "CM-54031" ||  a== "CM-50102" ||  a== "CM-50167" ||  a== "CM-50248" ||  a== "CM-50177" ||  a== "CM-50166" || a == "CM-50253" || a == "CM-60048" || a == "CM-54125" || a == "CM-91068" || a == "CM-50187" || a == "CM-50109" || a == "CM-99919" || a == "CM-50113" || a == "CM-50112" || a == "CM-50184" || a == "CM-61017" || a == "CM-50183" || a == "CM-50182" || a == "CM-02806" || a == "CM-99917"){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/MMsuvou2jhA');
          e.style.display="block";
      }  

    if(a == 'CM-60008'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/bKcab27D1fM');
          e.style.display="block";
      }

    if(a == 'CM-50340'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/zvaUDk-mz2k');
          e.style.display="block";
      }

    if(a == 'CM-60007'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/NtSA5wZC0NQ');
          e.style.display="block";
      }

    if(a == 'CM-30058'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/w9Qnh0JiNkg');
          e.style.display="block";
      }

    if(a == 'CM-30013'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/wSbWsGX7LDw');
          e.style.display="block";
      }

    if(a == 'CM-05358'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/i22iNkUmyyk');
          e.style.display="block";
      }

    if(a == 'CM-30060'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/i22iNkUmyyk');
          e.style.display="block";
      }

    if(a == 'CM-50096'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/qm3r8B3JusE');
          e.style.display="block";
      }

    if(a == 'CM-05346'  ||  a== "CM-05347"){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/GpTW5TKcP-I');
          e.style.display="block";
      }

    if(a == 'CM-91056'  ||  a == 'CM-91067'  ||  a == 'CM-91055'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/r-KVHjZEsxw');
          e.style.display="block";
      }

    if(a == 'CM-50087'  ||  a == 'CM-50086'  ||  a == 'CM-50088'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/CwNoKrtG3Ag');
          e.style.display="block";
      }


    if(a == 'CM-05050'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/ZNcH47hwph0');
          e.style.display="block";
      }

    if(a == 'CM-91059'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/m8Ts2E5D9MY');
          e.style.display="block";
      }

    if(a == 'CM-50163'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/dAL0PkBK-Io');
          e.style.display="block";
      }

if(a == 'CM-50252'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/h4xLBMokeAA');
          e.style.display="block";
      }

if(a == 'CM-54035'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/3ISVfXhBDoQ');
          e.style.display="block";
      }

  if(a == 'CM-99924'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/A2eNv8djx8g');
          e.style.display="block";
      }

  if(a == 'CM-60011'  ||  a == 'CM-60012' ){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/MJ9IAGFALnI');
          e.style.display="block";
      }

if(a == 'CM-55011'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/GV-Bas0JuJ0');
          e.style.display="block";
      }

if(a == 'CM-50254'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/OoKhdwu7evw');
          e.style.display="block";
      }

if(a == 'CM-30076' || a == 'CM-30077'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/iT65rtefQdQ');
          e.style.display="block";
      }

if(a == 'CM-54042'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/cAwbSq4WQ20');
          e.style.display="block";
      }

if(a == 'MO-19001' || a == 'MO-19000'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/6HxPPjNATTo?si=AcEoPGrKjWQd11fa');
          e.style.display="block";
      }

if(a == 'CM-80007' || a == 'CM-60405' || a == 'CM-60404' || a == 'CM-80008'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/48afxZYiVm0?si=2jyQIEDDt-VltutT');
          e.style.display="block";
      }
if(a == 'CM-61027' || a == 'CM-05454' || a == 'CM-61026' || a == 'CM-05453'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/OrCPEeHY0KM?si=-gsyptXGkk7D5ya9');
          e.style.display="block";
      }

if(a == 'CM-54050' || a == 'CM-60078' || a == 'CM-05430' || a == 'CM-60077'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/FVgC3okJfD4?si=Ttwfx_g_18H-3_sQ');
          e.style.display="block";
      }

if(a == 'CM-60022' || a == 'CM-60021' || a == 'CM-60023' || a == 'CM-54053'  || a == 'CM-54052'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/Y3dIWfb28Ag?si=B7sjTfIWPG_Gt1lI');
          e.style.display="block";
      }

if(a == 'CM-50264' || a == 'CM-50265'){
          var e = document.getElementById("Reviewvideo");
          e.setAttribute('src','https://www.youtube.com/embed/95HJXp9vOzk?si=1k4Jf-tH1V8rLXHd');
          e.style.display="block";
      }

//////////////////////////////////////////////////////////////////

jQuery(document).ready(function(){

  if (screen.width > 1024){ let ubp = 0; jQuery(window).scroll(function(){ let start_scroll = jQuery(window).scrollTop(); if(ubp == 0 && start_scroll >= 140){ jQuery(".header_dec").addClass('assignColor'); ubp = 1; } if(ubp == 1 && start_scroll <= 139){ jQuery(".header_dec").removeClass('assignColor'); ubp = 0; } });}
  if (screen.width > 1024){ jQuery(window).scroll(function() { if (jQuery(this).scrollTop() > 450) { jQuery('a.scroll-top').fadeIn('slow'); } else { jQuery('a.scroll-top').fadeOut('slow'); } }); jQuery('a.scroll-top').click(function(event) { event.preventDefault(); jQuery('html, body').animate({scrollTop: 0}, 600); }); }  
  jQuery("#moreInfo").click(function(){ jQuery("#footer_hide").slideToggle("slow"); jQuery("html, body").animate({ scrollTop: $(document).height() }, 1000); });  
  jQuery( "#menu_desktop a" ).hover(function() { var a = $(this).attr('data-info'); jQuery('.submenus').removeClass('active'); jQuery('#'+a).addClass('active'); });
  if (screen.width < 679){jQuery("div#shopify-section-footer").css('position','relative');}
  jQuery(".submenus").hover(function(){var e = jQuery(this).attr('id');jQuery("li[data-value]").removeClass('activar_gb');jQuery("li[data-value='" + e +  "']").addClass('activar_gb');});
  jQuery("li[data-value]").hover(function(){jQuery("li[data-value]").removeClass('activar_gb');});  
  jQuery("#menu_movile_o ul li>a").click(function(){ var tg = "#" + jQuery(this).attr('data-info');jQuery(tg).toggle(500);});
  jQuery("#menu_expo_mobile").click(function(){jQuery("div#menu_movile_o").show(500); });
  jQuery("#closedMenum").click(function(){	jQuery("div#menu_movile_o").hide(500); });  
  jQuery("#RecoverPassword").click(function(){	jQuery("#CustomeRecoverForm").show(); jQuery("#CustomerLoginForm").hide();});
  jQuery("#HideRecoverPasswordLink").click(function(){jQuery("#CustomeRecoverForm").hide(); jQuery("#CustomerLoginForm").show(); });
  // ############################### CODIGO DEL BUSCADOR #############################################
  var currentUrl = new URL(window.location.protocol + '//' + window.location.host);  
  jQuery("#predictiveSearch").on('paste', function(e) {	getValSearch(e.originalEvent.clipboardData.getData('text')); });  
  jQuery("#predictiveSearch").keyup(function(){ var a = jQuery(this).val(); getValSearch(a); });
  jQuery("#predictiveSearch").focusout(function(){ var a = jQuery(this).val(); if(a == ""){ jQuery("#resultSearch").html(""); } });
  function getValSearch(e){
    
     fetch(currentUrl + "search?view=ajax&q=" + e + "&type=product&options%5Bunavailable_products%5D=hide", {
          method: 'GET',
          credentials: 'same-origin'
        }).then(function (response) {
          response.text().then(function (content) {
            var linkSearchResults = document.querySelector('#resultSearch');

            if (linkSearchResults && content.trim() !== '') {
              linkSearchResults.innerHTML = content;
              jQuery("#resultSearch").fadeIn(200);
              
             jQuery( "ul#searchConsole li" ).focus(function(){
            	 jQuery("#resultSearch").fadeIn(300);
             });

            }else{
              linkSearchResults.innerHTML = '<h1 style="font-size:14px;">No se encontrarón resultados.</h1>';
            }        
            
            jQuery( "ul#searchConsole li" ).focusout(function(){
            	// jQuery("#resultSearch").fadeOut(600);
            });
            
          });
        });    
  }
  jQuery(".ulmenus-flex li").click(function(){ jQuery(".ulmenus-flex li").removeClass("active_tabs"); jQuery(".ulmenus-flex li hr").removeClass("active_tabs_hr"); jQuery(this).addClass("active_tabs"); var a = jQuery(this).attr('data-info'); jQuery("#tabs_products_li > div").removeClass('active_panel_tab'); jQuery("."+a).addClass('active_panel_tab');});
  jQuery(".card-tags__collection h4 a").click(function(){ let a = jQuery(this).attr('data-id'); let b = jQuery(this).attr('data-view'); if(b == 'false'){ jQuery(a).slideDown(500); jQuery(this).attr('data-view','true'); }else{ jQuery(a).slideUp(500); jQuery(this).attr('data-view','false'); }});
  jQuery(".panel_contain_product_ img").click(function(){ let src = jQuery(this).attr('src'); jQuery("#imgp-firts").attr('src',src); })
  jQuery("button.btnUpDown.btnUp").click(function(){ let qt = jQuery(this).attr('data-qty');let inf = jQuery(this).attr('data-info'); qt = parseInt(qt) + 1; jQuery("input[id='" + inf + "']").val(qt); jQuery("button[name='update']").click(); });
  jQuery("button.btnUpDown.btnDown").click(function(){let qt = jQuery(this).attr('data-qty'); let inf = jQuery(this).attr('data-info'); qt = parseInt(qt) - 1; jQuery("input[id='" + inf + "']").val(qt);jQuery("button[name='update']").click();});
  jQuery(".card-tags__collection.panel-tag_filter h2").click(function(){	jQuery(".card-tags__collection.filtros_mobiles").slideDown(600);  });
  jQuery(".filters__mobile_closed button.kafa__bton").click(function(){jQuery(".card-tags__collection.filtros_mobiles").slideUp(600); });
  jQuery("#closedAddAddress").click(function(){jQuery(".panels_oscuro").slideUp(500);});
  jQuery(".panels_oscuro .kafa__bton__red").click(function(){ jQuery(".panels_oscuro").slideUp(500);});
  jQuery("div[class^=panel-oscuro_] .kafa__bton__red").click(function(){ jQuery("div[class^=panel-oscuro_]").slideUp(500);});
  jQuery("button.kafa__bton.kafa__bton__blue.btn.address-new-toggle").click(function(){jQuery(".panels_oscuro").slideDown(500); });
  jQuery("button.btn--link.address-edit-toggle").click(function(){var a = jQuery(this).attr("data-form-id"); jQuery("." + a).slideDown(500); });
  jQuery("a[id^='closedEditAddress_']").click(function(){	var a = jQuery(this).attr("data-form-id"); jQuery("." + a).slideUp(500); });  
  Shopify.CustomerAddress={
    toggleForm:function(e){
      var t=document.getElementById("edit_address_"+e),
          s=document.getElementById("view_address_"+e);
      return t.style.display="none"==t.style.display?"":"none",
        s.style.display="none"==s.style.display?"":"none",!1},
    toggleNewForm:function(){
      var e=document.getElementById("add_address");
      return e.style.display="none"==e.style.display?"":"none",!1},
    destroy:function(e,t){
      //console.log(e + " - " + t )
      confirm(t||"Are you sure you wish to delete this address?")&&Shopify.postLink("/account/addresses/"+e,{parameters:{_method:"delete"}})
    }
  };
  jQuery("#iue1 a").click(function(){ jQuery("#iue1 a").removeClass("activeApp"); var a = jQuery(this).attr('data-id'); jQuery(this).addClass("activeApp"); jQuery("#iue2 .kafa-col-twelve.kafa-col-mt-twelve").hide(); jQuery(a).show();});
  jQuery("#icon_movile_search").click(function(){if(jQuery(this).attr("data-slide") == 'false'){ jQuery("#search_movile_ssa").slideDown(500); jQuery(this).attr("data-slide","true"); }else{ jQuery("#search_movile_ssa").slideUp(500); jQuery(this).attr("data-slide","false"); }});
  jQuery("#term").click(function(){if(jQuery(this).is(':checked')){ jQuery("#submitLogin").removeAttr('disabled');jQuery("#submitLogin").removeClass('diseabled_button');}else{ jQuery("#submitLogin").attr('disabled','disabled'); jQuery("#submitLogin").addClass('diseabled_button');}});
  jQuery("#term_re").click(function(){ if(jQuery(this).is(':checked')){ jQuery("#submitRegisterVal").removeAttr('disabled');jQuery("#submitRegisterVal").removeClass('diseabled_button'); }else{ jQuery("#submitRegisterVal").attr('disabled','disabled');jQuery("#submitRegisterVal").addClass('diseabled_button'); } });
  jQuery("#orderCollection").change(function(){let f = jQuery(this).val(); let urlC= window.location+'';urlC = urlC.split('?')[0]; window.location.href = urlC + "?sort_by=" + f; });  
  
});

var c = 0;
jQuery(document).ready(function(){
    var myVar = setInterval(function(){
        jQuery(".eapps-widget-toolbar").css('display','none');
        jQuery(".eapps-widget-toolbar-panel-views.eapps-widget-toolbar-panel-views-green").css('display','none');
        jQuery("a[href='https://apps.elfsight.com/panel/applications/google-reviews/edit/632613ae-8f72-4158-bf85-15cd6f130698/?utm_source=clients&amp;utm_medium=user-panel&amp;utm_campaign=edit-widget&amp;utm_content=google-reviews&amp;utm_term=grupodecme.com']").css('display','none');
        jQuery("a[href='https://elfsight.com/google-reviews-widget/?utm_source=websites&utm_medium=clients&utm_content=google-reviews&utm_term=grupodecme.com&utm_campaign=free-widget']").remove();
        if(c == 10){
            clearInterval(myVar);
        }else{
            c = c + 1;
        }
        
    }, 2000);
    
});


jQuery(document).ready(function(){  
  	

	jQuery('#support_register_form').submit(function (ev) {
      
      if(jQuery('#yusdInt').val() == 'qGphJD'){
      
        jQuery.ajax({
              type: jQuery('#support_register_form').attr('method'), 
              url: jQuery('#support_register_form').attr('action'),
              data: new FormData(this),
              contentType: false,
              cache: false,
              processData:false,
              beforeSend: function(){
                jQuery('#loaderSa').css("display","block");
            },
              success: function (data) {
                //alert(data); 
                //jQuery('#loaderSa').css("display","none");
				jQuery("#content_msg_sa").html("");
  				jQuery("#content_msg_sa").html('<p>' + data + '</p><p><button class="kafa__bton kafa__bton__red" id="closed_msg_s">Cerrar</button></p>');
                jQuery("#closed_msg_s").click(function(){
					location.reload();
				});                
            } 
        });	  
        
      }else{
      	alert("La captcha es incorrecta, favor de verificar!");
      }
      ev.preventDefault();
      
	});

	jQuery("#evidencias_pro").change(function(){
        var fileLength = this.files.length;
        var match= ["image/jpeg","image/png","image/jpg","image/gif"];
        var i;
        for(i = 0; i < fileLength; i++){ 
            var file = this.files[i];
            var imagefile = file.type;
            if(!((imagefile==match[0]) || (imagefile==match[1]) || (imagefile==match[2]) || (imagefile==match[3]))){
                alert('Por favor seleccione un formato valido de imagen (JPEG/JPG/PNG/GIF).');
                jQuery("#evidencias_pro").val('');
                return false;
            }
        }
   });
  	
  jQuery('#video_src').click(function(){jQuery('.flotante').slideToggle('slow'); document.getElementById("video_central").play(); });
  jQuery(".btn_closet_video").click(function(){	jQuery('.flotante').slideToggle('slow'); document.getElementById("video_central").pause(); });
  jQuery(".kafa__proudcts_courusell-desktop").click(function(){ var a = jQuery(this).attr('data-fist'); var b = jQuery(this).attr('data-bigs'); jQuery("#imgp-firts-desktop").attr('src',a); jQuery("#bigimage").attr('src',b);});

});

jQuery("#close_modal_shared").click(function(){
	jQuery(".panel-principal-shared").hide();
});
jQuery("#compartir_btn").click(function(){
	jQuery(".panel-principal-shared").show();
});

$('.panel-principal-shared').on('click', function(e) {
  if (e.target !== this)
    return;  
  jQuery(".panel-principal-shared").hide();
});

jQuery("#medos_dsi").click(function(){
	jQuery(".modal_envio").show();
});

jQuery('.modal_envio').on('click', function(e) {
  if (e.target !== this)
    return;  
  jQuery(".modal_envio").hide();
});	


// FUNCION PARA CERRAR MODAL ENVIO
jQuery('#modal_tiempo_envio').on('click', function(e) {
  if (e.target !== this)
    return;  
  jQuery("#modal_tiempo_envio").css("display","none");
});	
// Funcion para abrir el modal envio
jQuery("#modal_click_envio").click(function(){

    jQuery("#modal_tiempo_envio").css("display","flex");
    
});
//////////////////////////////////////////////// CODIGO DE CONTADOR ////////////////////////////////////////////////////////
(function ($) {
	'use strict';
	$.fn.countdown = function (options) {
		return $.fn.countdown.begin(this, $.extend({
			year: 2016, // YYYY Format
			month: 1, // 1-12
			day: 1, // 1-31
			hour: 0, // 24 hour format 0-23
			minute: 0, // 0-59
			second: 0, // 0-59
			timezone: -6, // http://en.wikipedia.org/wiki/List_of_tz_database_time_zones
			labels: true, // If false days hours seconds and monutes labels will not be created
			onFinish: function () { }  // Executes client side when timer is zero
		}, options));
	};

	$.fn.countdown.begin = function (parent, settings) {

		// Define Variables
		var timespan, start, end;

		// Define Target Date/time
		end = new Date(settings.year, settings.month - 1, settings.day, settings.hour, settings.minute, settings.second);

		// Converts Local Timezone to Target Timezone
		start = $.fn.countdown.convertTimezone(settings.timezone);

		// Defines countdown data
		timespan = $.fn.countdown.getTimeRemaining(start, end, settings);

		// Check if the script has run before
		if (!settings.init) {

			// Create elements
			$.each(timespan, function (k, v) {
				// Define variables being used
				var container, wrapper, time, label;

				// Create elements container
				container = $('<div/>').addClass('kafa-col-bg-three kafa-col-mt-three').attr('id', k);

				// Create wrapper element
				wrapper = $('<div/>').addClass('wrapperw');

				// Create time element
				time = $('<span/>').addClass('time').text(v < 10 ? '0' + v : v.toLocaleString());

				if (settings.labels) {
					// Create label element
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'days'){
						label = $('<span/>').addClass('label').text('Dias');
					}
                  	if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'day'){
						label = $('<span/>').addClass('label').text('Dia');
					}
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'hours'){
						label = $('<span/>').addClass('label').text('Hrs.');
					}
                    if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'hour'){
						label = $('<span/>').addClass('label').text('Hr.');
					}
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'minutes'){
						label = $('<span/>').addClass('label').text('Min.');
					}
                    if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'minute'){
						label = $('<span/>').addClass('label').text('Min.');
					}
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'seconds'){
						label = $('<span/>').addClass('label').text('Seg.');
					}
                    if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'second'){
						label = $('<span/>').addClass('label').text('Seg.');
					}
					// Add everything to container element
					container.append(wrapper.append(time).append(label));
				} else {
					container.append(wrapper.append(time));
				}

				// Add elements to parent element
				parent.append(container.addClass('animated rotateIn'));
			});

			// Tell the script that it has already been run
			settings.init = true;
		} else {
			// Update each element
			$.each(timespan, function (k, v) {
				var label = "";              	
                            
              		$('.time', '#' + k).text(v < 10 ? '0' + v : v.toLocaleString());
                    
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'days'){						
						label = 'Días'
					}
              		if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'day'){						
						label = 'Día'
					}
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'hours'){
						label = 'Hrs.';
					}
              		if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'hour'){
						label = 'Hr.';
					}
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'minutes'){
						label = 'Min.';
					}
              		if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'minute'){
						label = 'Min.';
					}
					if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'seconds'){
						label = 'Seg.';
					}
              		if((v === 1 ? $.fn.countdown.singularize(k) : k) == 'second'){
						label = 'Seg.';
					}
					$('.label', '#' + k).text(label);                          
					
			});
		}

		// Check if target date has beeen reached
		if (settings.target_reached) {

			// Executes function once timer reaches zero
			settings.onFinish();

		} else {

			// Updates the time every second for the visitor
			setTimeout(function () {
				$.fn.countdown.begin(parent, settings);
			}, 1000);
		}
	};

	// Removes the trailing S in days hours minutes seconds
	$.fn.countdown.singularize = function (str) {
		return str.substr(0, str.length - 1);
	};

	// Converts local timezone to target timezone
	$.fn.countdown.convertTimezone = function (timezone) {
		var now, local_time, local_offset, utc;
		now = new Date();
		local_time = now.getTime();
		local_offset = now.getTimezoneOffset() * 60000;
		utc = local_time + local_offset;
		return new Date(utc + (3600000 * timezone));
	};

	// Returns time remaining data for view
	$.fn.countdown.getTimeRemaining = function (start, end, settings) {
		var timeleft, remaining;
		remaining = {};
		timeleft = (end.getTime() - start.getTime());
		timeleft = (timeleft < 0 ? 0 : timeleft);

		// Check if target date has been reached
		if (timeleft === 0) {
			settings.target_reached = true;
		}

		// Built return object
		remaining.days = Math.floor(timeleft / (24 * 60 * 60 * 1000));
		remaining.hours = Math.floor((timeleft / (24 * 60 * 60 * 1000) - remaining.days) * 24);
		remaining.minutes = Math.floor(((timeleft / (24 * 60 * 60 * 1000) - remaining.days) * 24 - remaining.hours) * 60);
		remaining.seconds = Math.floor(timeleft / 1000 % 60);
		return remaining;
	};
}(jQuery));
//////////////////////////////////////////////// END CODIGO CONTADOR ///////////////////////////////////////////////////////


		 const cd = new Date().getFullYear() + 1
		 var de = new Date();
		 var strDate2 = de.getDate();
		 //console.log(strDate2);

		if( strDate2 == 09 ){
            $('#countdown').countdown({
                year: 2022,
                month: 05,
                day: 10,
                hour: 08,
                minute: 30,
                second: 00
             });
         }
		if( strDate2 == 10 ){
            $('#countdown').countdown({
                year: 2022,
                month: 05,
                day: 11,
                hour: 08,
                minute: 30,
                second: 00
            });
         }

		if( strDate2 == 11 ){
            $('#countdown').countdown({
                year: 2022,
                month: 05,
                day: 12,
                hour: 08,
                minute: 30,
                second: 00
            });
         }

		if( strDate2 == 12 ){
            $('#countdown').countdown({
                year: 2022,
                month: 05,
                day: 13,
                hour: 08,
                minute: 30,
                second: 00
            });
         }

		if( strDate2 == 13 ){
            $('#countdown').countdown({
                year: 2022,
                month: 05,
                day: 14,
                hour: 08,
                minute: 30,
                second: 00
            });
         }

		if( strDate2 == 14 ){
            $('#countdown').countdown({
                year: 2022,
                month: 05,
                day: 15,
                hour: 08,
                minute: 30,
                second: 00
            });
         }

//////////////////////////////////////////////// CODIGO DE CONTADOR ////////////////////////////////////////////////////////
(function ($) {
	'use strict';
	$.fn.countdown2 = function (options) {
		return $.fn.countdown2.begin(this, $.extend({
			year: 2016, // YYYY Format
			month: 1, // 1-12
			day: 1, // 1-31
			hour: 0, // 24 hour format 0-23
			minute: 0, // 0-59
			second: 0, // 0-59
			timezone: -6, // http://en.wikipedia.org/wiki/List_of_tz_database_time_zones
			labels: true, // If false days hours seconds and monutes labels will not be created
			onFinish: function () { }  // Executes client side when timer is zero
		}, options));
	};

	$.fn.countdown2.begin = function (parent, settings) {

		// Define Variables
		var timespan2, start2, end2;

		// Define Target Date/time
		end2 = new Date(settings.year, settings.month - 1, settings.day, settings.hour, settings.minute, settings.second);

		// Converts Local Timezone to Target Timezone
		start2 = $.fn.countdown2.convertTimezone(settings.timezone);

		// Defines countdown data
		timespan2 = $.fn.countdown2.getTimeRemaining(start2, end2, settings);

		// Check if the script has run before
		if (!settings.init) {

			// Create elements
			$.each(timespan2, function (k, v) {
				// Define variables being used
				var container2, wrapper2, time2, label2;

				// Create elements container
				container2 = $('<div/>').addClass('kafa-col-bg-three kafa-col-mt-three').attr('id', k+'2');

				// Create wrapper element
				wrapper2 = $('<div/>').addClass('wrapperw2');

				// Create time element
				time2 = $('<span/>').addClass('time2').text(v < 10 ? '0' + v : v.toLocaleString());

				if (settings.labels) {
					// Create label element
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'days'){
						label2 = $('<span/>').addClass('label2').text('Dias');
					}
                  	if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'day'){
						label2 = $('<span/>').addClass('label2').text('Dia');
					}
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'hours'){
						label2 = $('<span/>').addClass('label2').text('Hrs');
					}
                    if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'hour'){
						label2 = $('<span/>').addClass('label2').text('Hr');
					}
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'minutes'){
						label2 = $('<span/>').addClass('label2').text('Min');
					}
                    if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'minute'){
						label2 = $('<span/>').addClass('label2').text('Min');
					}
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'seconds'){
						label2 = $('<span/>').addClass('label2').text('Seg');
					}
                    if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'second'){
						label2 = $('<span/>').addClass('label2').text('Seg');
					}
					// Add everything to container element
					container2.append(wrapper2.append(time2).append(label2));
				} else {
					container2.append(wrapper2.append(time2));
				}

				// Add elements to parent element
				parent.append(container2.addClass('animated rotateIn'));
			});

			// Tell the script that it has already been run
			settings.init = true;
		} else {
			// Update each element
			$.each(timespan2, function (k, v) {
				var label = "";              	
                            
              		$('.time2','#' + k + '2' ).text(v < 10 ? '0' + v : v.toLocaleString());
              	    //console.log($('.time2','#' + k ).text());
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'days'){						
						label = 'Días'
					}
              		if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'day'){						
						label = 'Día'
					}
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'hours'){
						label = 'Hrs.';
					}
              		if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'hour'){
						label = 'Hr.';
					}
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'minutes'){
						label = 'Min.';
					}
              		if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'minute'){
						label = 'Min.';
					}
					if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'seconds'){
						label = 'Seg.';
					}
              		if((v === 1 ? $.fn.countdown2.singularize(k) : k) == 'second'){
						label = 'Seg.';
					}
					$('.label2', '#' + k + '2').text(label);                          
					
			});
		}

		// Check if target date has beeen reached
		if (settings.target_reached) {

			// Executes function once timer reaches zero
			settings.onFinish();

		} else {

			// Updates the time every second for the visitor
			setTimeout(function () {
				$.fn.countdown2.begin(parent, settings);
			}, 1000);
		}
	};

	// Removes the trailing S in days hours minutes seconds
	$.fn.countdown2.singularize = function (str) {
		return str.substr(0, str.length - 1);
	};

	// Converts local timezone to target timezone
	$.fn.countdown2.convertTimezone = function (timezone) {
		var now, local_time, local_offset, utc;
		now = new Date();
		local_time = now.getTime();
		local_offset = now.getTimezoneOffset() * 60000;
		utc = local_time + local_offset;
		return new Date(utc + (3600000 * timezone));
	};

	// Returns time remaining data for view
	$.fn.countdown2.getTimeRemaining = function (start, end, settings) {
		var timeleft, remaining;
		remaining = {};
		timeleft = (end.getTime() - start.getTime());
		timeleft = (timeleft < 0 ? 0 : timeleft);

		// Check if target date has been reached
		if (timeleft === 0) {
			settings.target_reached = true;
		}

		// Built return object
		remaining.days = Math.floor(timeleft / (24 * 60 * 60 * 1000));
		remaining.hours = Math.floor((timeleft / (24 * 60 * 60 * 1000) - remaining.days) * 24);
		remaining.minutes = Math.floor(((timeleft / (24 * 60 * 60 * 1000) - remaining.days) * 24 - remaining.hours) * 60);
		remaining.seconds = Math.floor(timeleft / 1000 % 60);
		return remaining;
	};
}(jQuery));
//////////////////////////////////////////////// END CODIGO CONTADOR ///////////////////////////////////////////////////////

const cd2 = new Date().getFullYear() + 1
	if( strDate2 == 09 ){
	$('#countdown2').countdown2({
            year: 2022,
            month: 05,
            day: 10,
            hour: 08,
            minute: 30,
            second: 00
        });
    }

	if( strDate2 == 10 ){
	$('#countdown2').countdown2({
            year: 2022,
            month: 05,
            day: 11,
            hour: 08,
            minute: 30,
            second: 00
        });
    }
	if( strDate2 == 11 ){
	$('#countdown2').countdown2({
            year: 2022,
            month: 05,
            day: 12,
            hour: 08,
            minute: 30,
            second: 00
        });
    }
if( strDate2 == 12 ){
	$('#countdown2').countdown2({
            year: 2022,
            month: 05,
            day: 13,
            hour: 08,
            minute: 30,
            second: 00
        });
    }
if( strDate2 == 13 ){
	$('#countdown2').countdown2({
            year: 2022,
            month: 05,
            day: 14,
            hour: 08,
            minute: 30,
            second: 00
        });
    }
if( strDate2 == 14 ){
	$('#countdown2').countdown2({
            year: 2022,
            month: 05,
            day: 15,
            hour: 08,
            minute: 30,
            second: 00
        });
    }
if( strDate2 == 15 ){
	$('#countdown2').countdown2({
            year: 2022,
            month: 05,
            day: 16,
            hour: 08,
            minute: 30,
            second: 00
        });
    }